import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import { FOOTER } from "@/constants/testIds";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid={FOOTER.root}
      className="relative border-t border-white/[0.06] bg-[#040710] pt-16 pb-10"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex flex-col items-start gap-3">
              <span className="relative inline-flex items-center">
                <span className="absolute -inset-x-6 -inset-y-3 rounded-full bg-[#007AFF]/10 blur-2xl" />
                <img
                  src="/pis-lockup-white.png"
                  alt="Polestar Innovation Solutions"
                  className="relative h-20 md:h-24 w-auto object-contain"
                />
              </span>
              <p className="text-[10px] uppercase tracking-[0.2em] text-white/40">
                Riyadh · KSA
              </p>
            </div>
            <p className="mt-5 max-w-sm text-sm text-[#8B95A5] leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-[11px] uppercase tracking-[0.22em] text-white/40">{t.footer.quick}</p>
            <ul className="mt-4 space-y-2 text-sm text-white/70">
              <li><a href="#what" className="hover:text-[#00F0FF] transition-colors">{t.nav.what}</a></li>
              <li><a href="#platforms" className="hover:text-[#00F0FF] transition-colors">{t.nav.platforms}</a></li>
              <li><a href="#cx" className="hover:text-[#00F0FF] transition-colors">{t.nav.cx}</a></li>
              <li><a href="#impact" className="hover:text-[#00F0FF] transition-colors">{t.nav.impact}</a></li>
              <li><a href="#founder" className="hover:text-[#00F0FF] transition-colors">{t.nav.founder}</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="text-[11px] uppercase tracking-[0.22em] text-white/40">{t.footer.ventures}</p>
            <ul className="mt-4 space-y-2 text-sm text-white/70">
              <li>ChainTwin</li>
              <li>Mashhoor</li>
              <li>Agri AI</li>
              <li>Urban AI</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="text-[11px] uppercase tracking-[0.22em] text-white/40">{t.footer.contact_h}</p>
            <ul className="mt-4 space-y-2 text-sm text-white/70">
              <li><a href="mailto:info@polestarb2b.com" className="hover:text-[#00F0FF] transition-colors">info@polestarb2b.com</a></li>
              <li>{t.contact.info.location}</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col md:flex-row items-center justify-between gap-3 border-t border-white/[0.06] pt-6">
          <p className="text-xs text-white/40">
            © {year} {t.footer.rights.replace(/©\s*/, "")}
          </p>
          <p className="text-[10px] uppercase tracking-[0.22em] text-white/30">
            Built in Riyadh · Vision 2030
          </p>
        </div>
      </div>
    </footer>
  );
}
